module.exports = __webpack_public_path__ + "d515f74b73a3ef144c4c254c3f0de34a.MP3";